import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Divider,
  Typography,
  ButtonBase,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useForm, Controller } from "react-hook-form";
import Vcode from "react-vcode";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../../components/Alert";
import Grid from "../../components/Grid";
import moment from "moment";
import { TextInput } from "../../components/Form";
import LoadingModal from "../../components/LoadingModal";

const GET_ERRORPROPERTY = gql`
  query errorProperty($id: Int!) {
    errorProperty(id: $id) {
      id
      reporter {
        id
        fullName
      }
      errorProperty
      errorLog
      imageUrl
      editor {
        id
        fullName
      }
      editMessage
      createdAt
      updatedAt
    }
  }
`;

const SAVE_ERRORPROPERTY = gql`
  mutation saveErrorProperty($errorPropertyInput: ErrorPropertyInput!) {
    saveErrorProperty(errorPropertyInput: $errorPropertyInput)
  }
`;

const UPLOAD_IMAGE = gql`
  mutation UploadImage($image: Upload!) {
    uploadImage(image: $image) {
      filename
      mimetype
      encoding
      location
    }
  }
`;

export default function ErrorLogReport({ data, onClose = () => {} }) {
  const { control, handleSubmit, setValue, getValues, reset, watch } = useForm({
    defaultValues: {
      reporterId: null,
      reporter: "",
      errorProperty: "",
      errorLog: "",
      imageUrl: "",
      editerId: null,
      editer: "",
      editMessage: "",
      vcode: "",
      createdAt: "",
    },
  });
  const imageUrl = watch("imageUrl");
  const [vcodeRandom, setVcodeRandom] = useState("");
  const Alert = useAlert();

  const [
    getErrorProperty,
    { data: getErrorPropertyData, loading: getErrorPropertyLoading },
  ] = useLazyQuery(GET_ERRORPROPERTY, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ errorProperty }) {
      if (errorProperty) {
        setValue("reporterId", errorProperty.reporter.id);
        setValue("reporter", errorProperty.reporter.fullName);
        setValue("errorProperty", errorProperty.errorProperty);
        setValue("errorLog", errorProperty.errorLog);
        setValue("createdAt", errorProperty.createdAt);
        if (errorProperty.imageUrl)
          setValue("imageUrl", errorProperty.imageUrl);
        if (errorProperty.editor) {
          setValue("editerId", errorProperty.editor?.id);
          setValue("editer", errorProperty.editor?.fullName);
          setValue("editMessage", errorProperty.editMessage);
        }
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [saveErrorProperty, { loading: saveErrorPropertyLoading }] =
    useMutation(SAVE_ERRORPROPERTY, {
      onCompleted({ saveErrorProperty }) {
        if (saveErrorProperty) {
          Alert.notice("儲存成功");
          return onClose();
        }
      },
      onError(error) {
        return Alert.notice(error.message.replace("GraphQL error: ", ""));
      },
    });
  const [uploadImage, { loading: uploadImageLoading }] = useMutation(
    UPLOAD_IMAGE,
    {
      onCompleted({ uploadImage }) {
        delete uploadImage.__typename;
        setValue("imageUrl", uploadImage.location);
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  useEffect(() => {
    if (data.open) {
      const str = "1234567890";
      let code = "";
      for (let i = 0; i < 4; i++) {
        const index = Math.floor(Math.random() * 10);
        code += str[index];
      }
      setVcodeRandom(code);
    } else {
      reset({
        errorLog: "",
        reporterId: null,
        errorProperty: "",
        imageUrl: "",
        editerId: null,
        editMessage: "",
        vcode: "",
      });
    }

    if (data.id) {
      getErrorProperty({ variables: { id: data.id } });
    }
  }, [data]);

  function save(InputData) {
    let errorPropertyInput = {
      reporterId: Number(localStorage.getItem("@fullhouseUserId")),
      errorProperty: data.logData
        ? data.logData.obj + "\n" + data.logData.address
        : getValues("errorProperty"),
      errorLog: InputData.errorLog,
    };
    if (imageUrl !== "") {
      errorPropertyInput.imageUrl = getValues("imageUrl");
    }
    if (data.id) {
      errorPropertyInput.id = data.id;
      errorPropertyInput.reporterId = getValues("reporterId");
      errorPropertyInput.errorProperty = getValues("errorProperty");
      errorPropertyInput.editorId = Number(
        localStorage.getItem("@fullhouseUserId")
      );
      errorPropertyInput.editMessage = InputData.editMessage;
    }
    saveErrorProperty({ variables: { errorPropertyInput } });
  }
  return (
    <Dialog
      open={data.open}
      onClose={onClose}
      maxWidth={data.id ? "md" : "sm"}
      fullWidth
    >
      <LoadingModal
        loading={
          uploadImageLoading ||
          saveErrorPropertyLoading ||
          getErrorPropertyLoading
        }
      />
      <DialogTitle align="center">
        {data.id ? "錯誤回報-回覆" : "錯誤回報"}
      </DialogTitle>
      <DialogContent>
        {data.id && (
          <>
            <Grid container spacing={1}>
              <Grid item sm={6}>
                <Typography color="primary">{"回報者"}</Typography>
                <Controller
                  name={"reporter"}
                  control={control}
                  render={({ field }) => <Typography>{field.value}</Typography>}
                />
              </Grid>
              <Grid item sm={6}>
                <Typography color="primary">{"回報時間"}</Typography>
                <Controller
                  name={"createdAt"}
                  control={control}
                  render={({ field }) => (
                    <Typography>
                      {moment(field.value).format("yyyy-MM-DD")}
                    </Typography>
                  )}
                />
              </Grid>
              <Grid item sm={12}>
                <Typography color="primary">錯誤物件</Typography>
                <Controller
                  name={"errorProperty"}
                  control={control}
                  render={({ field }) => <Typography>{field.value}</Typography>}
                />
              </Grid>
              <Grid item sm={12}>
                <Typography color="primary">{"回報說明"}</Typography>
                <Controller
                  name={"errorLog"}
                  control={control}
                  render={({ field }) => <Typography>{field.value}</Typography>}
                />
              </Grid>
              {imageUrl !== "" && (
                <Grid item sm={12}>
                  <Typography color="primary">圖片</Typography>
                  <Controller
                    name={"imageUrl"}
                    control={control}
                    render={({ field }) => (
                      <img
                        src={field.value}
                        style={{
                          width: "100%",
                          height: "300px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  />
                </Grid>
              )}
            </Grid>
            <Divider style={{ margin: "1em" }} />
          </>
        )}
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <Typography color="primary">
              {data.id ? "修訂者" : "回報者"}
            </Typography>
            <Typography>
              {data.id
                ? getErrorPropertyData?.errorProperty?.reporter.fullName
                : localStorage.getItem("@fullhouseUserFullName")}
            </Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography color="primary">IP</Typography>
            <Typography>
              {localStorage.getItem("@fullhouseIpAddress")}
            </Typography>
          </Grid>
          {!data.id && (
            <Grid item sm={12}>
              <Typography color="primary">錯誤物件</Typography>
              <Typography style={{ whiteSpace: "pre-wrap" }}>
                {data.logData
                  ? data.logData.obj + "\n" + data.logData.address
                  : getValues("errorProperty")}
              </Typography>
            </Grid>
          )}
          <Grid item sm={12}>
            <Typography color="primary">
              {data.id ? "修訂說明" : "回報說明"}
            </Typography>
            <Controller
              name={data.id ? "editMessage" : "errorLog"}
              control={control}
              rules={{
                required: data.id ? "請輸入修訂說明" : "請輸入回報說明",
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  error={error}
                  helperText={error && error.message}
                  multiline
                  fullWidth
                />
              )}
            />
          </Grid>
          {!data.id && (
            <Grid item sm={12}>
              <Typography color="primary">上傳圖片</Typography>
              <Controller
                name="imageUrl"
                control={control}
                render={({ field }) => (
                  <Box
                    display="flex"
                    flex={1}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <ButtonBase
                      style={{ flex: 1, height: 150 }}
                      component="label"
                      htmlFor={"coverImage"}
                      disabled={!!data.id}
                    >
                      {field.value ? (
                        <img
                          src={field.value}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <CloudUploadIcon />
                      )}
                    </ButtonBase>
                    <>
                      <input
                        id={"coverImage"}
                        type="file"
                        accept="image/*"
                        onChange={(event) => {
                          const {
                            target: {
                              validity,
                              files: [file],
                            },
                          } = event;

                          if (validity.valid) {
                            uploadImage({ variables: { image: file } });
                          }
                        }}
                        style={{
                          display: "none",
                        }}
                      />
                    </>
                  </Box>
                )}
              />
            </Grid>
          )}
          <Grid item sm={6}>
            <Typography color="primary">輸入驗證碼</Typography>
            <Controller
              name="vcode"
              control={control}
              rules={{
                validate: (v) => {
                  if (v !== vcodeRandom) return "驗證碼錯誤";
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  multiline
                  error={error}
                  helperText={error && error.message}
                  fullWidth
                />
              )}
            />
            {vcodeRandom !== "" && (
              <Vcode value={vcodeRandom} length={4} width={150} height={40} />
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1} justifyContent="center">
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmit(save)}
            >
              送出
            </Button>
          </Grid>
          <Grid item>
            <Button color="primary" variant="outlined" onClick={onClose}>
              關閉
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
